import { render, staticRenderFns } from "./SingleClientCOF.vue?vue&type=template&id=1eafa88a&"
import script from "./SingleClientCOF.vue?vue&type=script&lang=js&"
export * from "./SingleClientCOF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports